(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["akcn-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["akcn-product-mobile-nine"] && !Shopify.designMode) return;
  try {
    
  /* AKCN Mobile Product Page — Swipe + Auto-Advance + Parallax + Tabs */
  (function () {
    const root = document.querySelector('[data-akcn-product-mobile]');
    if (!root) return;

    /* Nur auf Mobile aktiv */
    if (window.innerWidth >= 750) return;

    const track = root.querySelector('[data-track]');
    const slides = root.querySelectorAll('.akcn-pm__slide');
    const dots = root.querySelectorAll('[data-dots] .akcn-pm__dot');
    const thumbs = root.querySelectorAll('.akcn-pm__thumb');
    const gallery = root.querySelector('[data-gallery]');
    const parallaxEl = root.querySelector('[data-parallax]');

    let current = 0;
    let autoplayTimer = null;
    const autoplaySeconds = parseInt(root.dataset.autoplay || '5', 10);

    function pauseInactiveVideos() {
      slides.forEach((s, idx) => {
        const v = s.querySelector('video');
        if (!v) return;
        if (idx === current) { v.play().catch(() => {}); }
        else { v.pause(); }
      });
    }
    function goTo(i) {
      if (!slides.length) return;
      current = ((i % slides.length) + slides.length) % slides.length;
      slides.forEach((s, idx) => s.classList.toggle('is-active', idx === current));
      dots.forEach((d, idx) => d.classList.toggle('is-active', idx === current));
      thumbs.forEach((t, idx) => t.classList.toggle('is-active', idx === current));
      pauseInactiveVideos();
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      stopAutoplay();
      if (slides.length < 2) return;
      autoplayTimer = setInterval(next, autoplaySeconds * 1000);
    }
    function stopAutoplay() { if (autoplayTimer) { clearInterval(autoplayTimer); autoplayTimer = null; } }

    /* Click auf Dots und Thumbs */
    dots.forEach(d => d.addEventListener('click', () => { goTo(parseInt(d.dataset.go, 10)); stopAutoplay(); startAutoplay(); }));
    thumbs.forEach(t => t.addEventListener('click', () => { goTo(parseInt(t.dataset.go, 10)); stopAutoplay(); startAutoplay(); }));

    /* Touch-Swipe */
    let touchStartX = 0, touchStartY = 0, touchDelta = 0, touching = false;
    const SWIPE_THRESHOLD = 40;

    gallery.addEventListener('touchstart', e => {
      touching = true;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchDelta = 0;
      stopAutoplay();
    }, { passive: true });

    gallery.addEventListener('touchmove', e => {
      if (!touching) return;
      touchDelta = e.touches[0].clientX - touchStartX;
      const dy = e.touches[0].clientY - touchStartY;
      /* Nur horizontal swipen wenn X-Movement > Y */
      if (Math.abs(touchDelta) > Math.abs(dy)) {
        e.preventDefault && e.preventDefault();
      }
    }, { passive: true });

    gallery.addEventListener('touchend', () => {
      if (!touching) return;
      touching = false;
      if (touchDelta > SWIPE_THRESHOLD) prev();
      else if (touchDelta < -SWIPE_THRESHOLD) next();
      startAutoplay();
    });

    /* Parallax — leichte Y-Verschiebung beim Scrollen */
    let parallaxRaf = null;
    function onScroll() {
      if (parallaxRaf) return;
      parallaxRaf = requestAnimationFrame(() => {
        if (parallaxEl) {
          const rect = parallaxEl.getBoundingClientRect();
          const scrollProgress = Math.max(0, Math.min(1, 1 - rect.bottom / (window.innerHeight + rect.height)));
          const offset = (scrollProgress - 0.5) * 30; /* max ±15px */
          parallaxEl.style.setProperty('--px-offset', offset + 'px');
        }
        parallaxRaf = null;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* Tabs */
    root.querySelectorAll('[data-tab-toggle]').forEach(btn => {
      btn.addEventListener('click', () => {
        const tab = btn.closest('[data-tab]');
        tab.classList.toggle('is-open');
      });
    });

    /* Sticky CTA scrollt zum Haupt-CTA */
    const stickyBtn = root.querySelector('[data-sticky-cta]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', () => {
        const form = root.querySelector('#akcn-pm-form button[name="add"]');
        if (form) form.click();
      });
    }

    /* THE NINE variant switcher */
    const vWrap = root.querySelector('[data-nine-variants]');
    if (vWrap) {
      const vBtns = vWrap.querySelectorAll('[data-nine-variant]');
      const vIdInput = root.querySelector('#akcn-pm-form input[name="id"]');
      const vCta = root.querySelector('#akcn-pm-form button[name="add"]');
      const vCtaSpan = vCta ? vCta.querySelector('span') : null;
      const vCount = root.querySelector('[data-nine-stock-count]');
      const vFill = root.querySelector('[data-nine-stock-fill]');
      const vTotal = parseInt(vWrap.dataset.total || '20', 10);
      vBtns.forEach(btn => btn.addEventListener('click', () => {
        vBtns.forEach(b => b.classList.toggle('is-active', b === btn));
        if (vIdInput) vIdInput.value = btn.dataset.variantId;
        const avail = btn.dataset.available === 'true';
        if (vCta) vCta.disabled = !avail;
        if (vCtaSpan) vCtaSpan.textContent = avail ? vWrap.dataset.ctaLabel : vWrap.dataset.soldoutLabel;
        const sold = Math.max(0, vTotal - parseInt(btn.dataset.qty || '0', 10));
        if (vCount) vCount.textContent = sold + ' / ' + vTotal + ' ' + (vWrap.dataset.stockLabel || 'vergeben');
        if (vFill) vFill.style.width = (vTotal ? Math.round(sold * 100 / vTotal) : 0) + '%';
        const vPrice = root.querySelector('[data-nine-price]');
        if (vPrice && btn.dataset.price) vPrice.textContent = btn.dataset.price;
        const vCompare = root.querySelector('[data-nine-compare]');
        if (vCompare) {
          vCompare.textContent = btn.dataset.compare || '';
          vCompare.style.display = btn.dataset.compare ? '' : 'none';
        }
        goTo(parseInt(btn.dataset.imageIndex || '0', 10));
      }));
    }

    /* Start */
    startAutoplay();

    /* Pausiere Autoplay wenn Tab im Hintergrund */
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopAutoplay();
      else startAutoplay();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["akcn-product-mobile"] && !Shopify.designMode) return;
  try {
    
  /* AKCN Mobile Product Page — Swipe + Auto-Advance + Parallax + Tabs */
  (function () {
    const root = document.querySelector('[data-akcn-product-mobile]');
    if (!root) return;

    /* Nur auf Mobile aktiv */
    if (window.innerWidth >= 750) return;

    const track = root.querySelector('[data-track]');
    const slides = root.querySelectorAll('.akcn-pm__slide');
    const dots = root.querySelectorAll('[data-dots] .akcn-pm__dot');
    const thumbs = root.querySelectorAll('.akcn-pm__thumb');
    const gallery = root.querySelector('[data-gallery]');
    const parallaxEl = root.querySelector('[data-parallax]');

    let current = 0;
    let autoplayTimer = null;
    const autoplaySeconds = parseInt(root.dataset.autoplay || '5', 10);

    function goTo(i) {
      if (!slides.length) return;
      current = ((i % slides.length) + slides.length) % slides.length;
      slides.forEach((s, idx) => s.classList.toggle('is-active', idx === current));
      dots.forEach((d, idx) => d.classList.toggle('is-active', idx === current));
      thumbs.forEach((t, idx) => t.classList.toggle('is-active', idx === current));
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      stopAutoplay();
      if (slides.length < 2) return;
      autoplayTimer = setInterval(next, autoplaySeconds * 1000);
    }
    function stopAutoplay() { if (autoplayTimer) { clearInterval(autoplayTimer); autoplayTimer = null; } }

    /* Click auf Dots und Thumbs */
    dots.forEach(d => d.addEventListener('click', () => { goTo(parseInt(d.dataset.go, 10)); stopAutoplay(); startAutoplay(); }));
    thumbs.forEach(t => t.addEventListener('click', () => { goTo(parseInt(t.dataset.go, 10)); stopAutoplay(); startAutoplay(); }));

    /* Touch-Swipe */
    let touchStartX = 0, touchStartY = 0, touchDelta = 0, touching = false;
    const SWIPE_THRESHOLD = 40;

    gallery.addEventListener('touchstart', e => {
      touching = true;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchDelta = 0;
      stopAutoplay();
    }, { passive: true });

    gallery.addEventListener('touchmove', e => {
      if (!touching) return;
      touchDelta = e.touches[0].clientX - touchStartX;
      const dy = e.touches[0].clientY - touchStartY;
      /* Nur horizontal swipen wenn X-Movement > Y */
      if (Math.abs(touchDelta) > Math.abs(dy)) {
        e.preventDefault && e.preventDefault();
      }
    }, { passive: true });

    gallery.addEventListener('touchend', () => {
      if (!touching) return;
      touching = false;
      if (touchDelta > SWIPE_THRESHOLD) prev();
      else if (touchDelta < -SWIPE_THRESHOLD) next();
      startAutoplay();
    });

    /* Parallax — leichte Y-Verschiebung beim Scrollen */
    let parallaxRaf = null;
    function onScroll() {
      if (parallaxRaf) return;
      parallaxRaf = requestAnimationFrame(() => {
        if (parallaxEl) {
          const rect = parallaxEl.getBoundingClientRect();
          const scrollProgress = Math.max(0, Math.min(1, 1 - rect.bottom / (window.innerHeight + rect.height)));
          const offset = (scrollProgress - 0.5) * 30; /* max ±15px */
          parallaxEl.style.setProperty('--px-offset', offset + 'px');
        }
        parallaxRaf = null;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* Tabs */
    root.querySelectorAll('[data-tab-toggle]').forEach(btn => {
      btn.addEventListener('click', () => {
        const tab = btn.closest('[data-tab]');
        tab.classList.toggle('is-open');
      });
    });

    /* Sticky CTA scrollt zum Haupt-CTA */
    const stickyBtn = root.querySelector('[data-sticky-cta]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', () => {
        const form = root.querySelector('#akcn-pm-form button[name="add"]');
        if (form) form.click();
      });
    }

    /* Start */
    startAutoplay();

    /* Pausiere Autoplay wenn Tab im Hintergrund */
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopAutoplay();
      else startAutoplay();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
